import { render } from "./IconServer.vue?vue&type=template&id=53f5c79d"
import script from "./IconServer.vue?vue&type=script&lang=js"
export * from "./IconServer.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miniapp-property-b2b/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/20/IconServer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53f5c79d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53f5c79d', __exports__)) {
    api.reload('53f5c79d', __exports__)
  }
  
  module.hot.accept("./IconServer.vue?vue&type=template&id=53f5c79d", () => {
    api.rerender('53f5c79d', render)
  })

}


export default __exports__